import React from 'react';
import { ResourceProps } from 'react-admin';

// Ajustes: administradores, parámetros del negocio, tareas del robot y el
// registro de auditoría. La pestaña se elige por `?t=`.
let resourceProps: ResourceProps = {
  name: 'settings',
  list: React.lazy(() => import(/* webpackChunkName: "c-ajustes" */ '../../console/pages/ajustes')),
};

export default resourceProps;
